export const OPCO_REGEX = {
  ALPHANUMERIC: /^[A-Za-z0-9]+$/,
  EMAIL: /\S+@\S+\.\S+/,
  ALPHABETIC: /^[a-zA-Z]+$/,
  ALPHABETICSPACE: /^[a-zA-Z _-]+$/,
  ALPHANUMERICSPACE: /^[A-Za-z0-9 _-]+$/
};

export const OPCO_VALIDATION_MESSAGES = {
  REQUIRED: 'is required.',
  EMAIL_REQUIRED: 'Email Address is required.',
  INVALID_EMAIL: 'Invalid email format.',
  MAX_50: 'Must be less than 50 characters.',
  MAX_20: 'Length should be less than 20 characters.',
  ALPHANUMERIC: 'Must be alphanumeric.',
  ALPHANUMERICSPACE:'Must be alphanumeric and may include space, _ or -',
  ALPHABETIC: 'Must be Alphabetic.',
  ALPHABETICSPACE: 'Must be alphabetic and may include space, _ or -',
  NON_NEGATIVE_INT: 'Must be a non-negative integer.',
  ADD_SYS_DETAILS: 'Is required when "Yes" is selected.',
};

export const FEED_MENU_ITEMS = [
  { value: "csvfiles", label: "CSV Files" },
  { value: "apis", label: "API" },
  { value: "both", label: "Both" }
];
export const ERROR_MESSAGES = {
  NETWORK: "Unable to connect. Please check your internet connection and try again.",
  VALIDATION: "Some information is incorrect or missing.",
  SERVER_500: "Something went wrong. Please try again later.",
  SERVER_400: "There was a problem processing your request. Please review your input and try again.",
  FORM_VALIDATION: "Please fix the errors in the form before submitting.",
  UNKNOWN: "An unexpected error occurred. Please try again.",
  UPDATE_COMPANY_FAILED: "We couldn't update the company right now. Please try again.",
};


